import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core";
import {
  tCookingMethod,
  tPrescriptionHeadModel,
} from "src/app/models/tPrescriptionHeadModel";
import { tPrescriptionLineModel_PrintPrescription } from "src/app/models/tPrescriptionLineModel";
import { tConsultHeadModelWithPatientInfo } from "src/app/models/tConsultHeadModel";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import { tOnConsultService } from "src/app/services/tOnConsult.service";
import { isNullOrUndefined } from "util";
import { DatePipe } from "@angular/common";

import { tPrescriptionService } from "src/app/services/tPrescription.service";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";

import { tEmployeeService } from "src/app/services/tEmployee.service";
import { AppSettings } from "src/app/shared/AppSettings";
import { GenderModel } from "src/app/models/SimpleConfigModel";
import { tShopService } from "src/app/services/tShop.service";
import { ReportRoutingModule } from "src/app/report/report-routing.module";

export class PharmacyPrint {
  medi_category: string;
  medi_header: { col1: string; col2: string; col3: string };
  medi_totalWeight: number;
  medi_totalCount: string;
  medi_PharmacyLines: {
    l1: tPrescriptionLineModel_PrintPrescription[];
    l2: tPrescriptionLineModel_PrintPrescription[];
    l3: tPrescriptionLineModel_PrintPrescription[];
    l4: tPrescriptionLineModel_PrintPrescription[];
    l5: tPrescriptionLineModel_PrintPrescription[];
    l6: tPrescriptionLineModel_PrintPrescription[];
  };
}

@Component({
  selector: "app-prescription",
  templateUrl: "./prescription.component.html",
  styleUrls: ["./prescription.component.css"],
})
export class PrintPrescriptionComponent implements OnInit {
  TAG = "PrintPrescriptionComponent";

  // @ViewChildren('findButton') _findButton;
  // @ViewChild("autoClick") autoClick: ElementRef;

  urlStartingPath = AppSettings.shopAdapter.imagePath;
  picFullPath = this.urlStartingPath + "/assets/img/print/doc_logo.png";

  @Input() header: tPrescriptionHeadModel;
  @Input() line: tPrescriptionLineModel_PrintPrescription[];
  @Input() printMode: number;
  @Input() genderList: GenderModel[];

  onConsultDataList: tConsultHeadModelWithPatientInfo;

  patientGender_selection_Display = "";

  line1: tPrescriptionLineModel_PrintPrescription[] = new Array();
  line1_detail: tPrescriptionLineModel_PrintPrescription[] = new Array();
  line2: tPrescriptionLineModel_PrintPrescription[] = new Array();

  medi_no_details: tPrescriptionLineModel_PrintPrescription[] = [];

  mediQtyTotal = 0;

  cookingMethod_selection: tCookingMethod[] = [];

  emptylines = [];
  emptylines2 = [];

  totalPrintWithCustomer = 1; //藥方
  totalPrintWithStaff = 1; //藥方(藥房專用)

  shopNameTC = '';

  //藥方(藥房專用)
  prescriptionDetail: PharmacyPrint = {
    medi_category: "",
    medi_header: { col1: "藥物名稱", col2: "藥量", col3: "" },
    medi_totalWeight: 0,
    medi_totalCount: "",
    medi_PharmacyLines: {
      l1: [],
      l2: [],
      l3: [],
      l4: [],
      l5: [],
      l6: [],
    },
  };

  presPartA = {
    medi_category: "",
    medi_header: { col1: "藥物名稱", col2: "藥量", col3: "" },
    medi_specialLines: {
      l1: [],
      l2: [],
      l3: [],
      l4: [],
      l5: [],
      l6: [],
      l7: [],
      l8: [],
    },
    medi_lines: {
      l11: [],
      l12: [],
      l21: [],
      l22: [],
      l31: [],
      l32: [],
      l41: [],
      l42: [],
      l51: [],
      l52: [],
      l61: [],
      l62: [],
      l71: [],
      l72: [],
      l81: [],
      l82: [],
      l91: [],
      l92: [],
    },
    medi_Qty: "",
    blankLines: { b1: [], b2: [], b3: [], b4: [] },
  };

  shopInfo = {
    address_tc: "",
    address_en: "",
    telephone: "",
  };

  SIZE_MEDI_DETAIL = {
    "1050": 1050,
    "2100": 2100,
    "3150": 3150,
  };

  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private tOnConsultService: tOnConsultService,
    private dateTimeConvertService: DateTimeConvertService,
    public datepipe: DatePipe,
    private tPrescriptionService: tPrescriptionService,
    private tEmployeeService: tEmployeeService,
    private tShopService: tShopService
  ) {}

  ngOnInit() {
    console.log(JSON.stringify(this.header));
    this.GettCookingMethod();
    this.initShopInfo();
    this.getPrintLine(this.header.prescriptionNumber);
    this.initGetConsultEmployee();
    this.setTotalMediQty();
    this.setPresDetail();
    this.setPresPartA();
    //console.table(this.header);
  }
  ngAfterViewInit() {
    // let inputElement: HTMLElement = this.autoClick.nativeElement as HTMLElement;
    // setTimeout(() => {
    //   inputElement.click();
    //   this.activeModal.close("Close click");
    //   // And any other code that should run only after 5s
    // }, 1200);
  }
  initShopInfo() {
    //call api to get tShop master by shopID
    const shopID = this.header.shopID;

    this.shopInfo.address_tc = "address_tc";
    this.shopInfo.telephone = "telephone";

    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shopInfo.address_en =
          res.shopAddressEng1 + res.shopAddressEng2 + res.shopAddressEng3;
        this.shopInfo.address_tc =
          res.shopAddress1 + res.shopAddress2 + res.shopAddress3;
        this.shopInfo.telephone = res.shopPhone;
        this.shopNameTC = res.shopName;
        //// console.table(this.shopInfo);
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  initGetConsultEmployee() {
    if (!isNullOrUndefined(this.header.remark2)) {
      //get consult head number
      this.tEmployeeService
        .getDataById(
          1, // NavigationComponent.selectedShopID,
          this.header.remark2.toString()
        )
        .subscribe((therapisdata) => {
          this.header.remark3 = therapisdata.employeeChiName;
          this.header.remark4 = therapisdata.drRegNo;

          //console.table(this.header);
          // // console.table(this.line);
        });
    }
  }

  //inital Prescription PartA
  setPresPartA() {
    this.presPartA.medi_category = this.getPresPartA_mediCategory();
    this.presPartA.medi_Qty = this.getPresPartA_mediQty();
  }

  getPresPartA_mediCategory() {
    if (this.header.prescriptionCateID === "b01") return "中草藥";
    else if (this.header.prescriptionCateID === "b02") return "顆粒";
    return this.header.prescriptionCateName;
  }

  getPresPartA_mediQty() {
    const header = this.header;
    if (
      header.prescriptionCateID === "b01" ||
      header.prescriptionCateID === "b03"
    ) {
      return (
        this.line.length +" 種藥品, " +
        header.prescriptionQuantity +
        " 劑 , 服用 " +
        header.prescriptionQuantity +
        " 日 , 每天服用 1 劑 , 每劑服用" +
        header.dailyTimes +
        " 次"
      );
    } else if (header.prescriptionCateID === "b02") {
      //console.table(header);
      return (
        this.line.length +" 種藥品, " +
        header.prescriptionDays +
        "劑 , 服用 " +
        header.prescriptionDays +
        " 日, 每天服用" +
        header.dailyTimes +
        " 次, 每次 " +
        header.finalTtlPack +
        " 包, 共" +
        header.prescriptionQuantity +
        "包"
      );
    }

    return "";
  }

  //inital Prescription (藥房專用) PartB
  setPresDetail() {
    this.setPresDetail_mediCategory();
    this.setPresDetail_mediHeader();
    this.setPresDetail_mediTotalWeight();
    this.setPresDetail_mediTotalCount();
  }

  setPresDetail_mediCategory() {
    this.prescriptionDetail.medi_category = this.header.prescriptionCateName;
    if (this.header.prescriptionCateID === "b01")
      this.prescriptionDetail.medi_category = "中草藥";
    else if (this.header.prescriptionCateID === "b02")
      this.prescriptionDetail.medi_category = "顆粒";
  }

  setPresDetail_mediHeader() {
    this.prescriptionDetail.medi_header.col3 = "備註";
    if (this.header.prescriptionCateID === "b01")
      this.prescriptionDetail.medi_header.col3 = "備註";
    else if (this.header.prescriptionCateID === "b02")
      this.prescriptionDetail.medi_header.col3 = "藥物編號";
  }

  setPresDetail_mediTotalWeight() {
    //console.table(this.line);
    this.prescriptionDetail.medi_totalWeight = this.line
      .map((el) => el.prescriptionTotalQty)
      .reduce((a, b) => Number(a.toFixed(1)) + Number(b.toFixed(1)), 0);
  }

  setPresDetail_mediTotalCount() {
    this.prescriptionDetail.medi_totalCount = "";
    if (
      this.header.prescriptionCateID === "b01" ||
      this.header.prescriptionCateID === "b03"
    )
      //中草藥
      this.prescriptionDetail.medi_totalCount =
        this.line.length +
        " 種藥品, 共 " +
        this.header.prescriptionQuantity +
        " 劑 服用 " +
        this.header.prescriptionQuantity +
        " 日 每日服用 1 劑 每劑服用 " +
        this.header.dailyTimes +
        " 次";
    else if (this.header.prescriptionCateID === "b02")
      //顆粒(濃縮中藥)
      this.prescriptionDetail.medi_totalCount =
      this.line.length + " 種藥品," +
        " 共 " +
        this.header.prescriptionDays +
        " 劑 服用 " +
        this.header.prescriptionDays +
        " 日 每日服用" +
        this.header.dailyTimes +
        "次 每次 " +
        this.header.finalTtlPack +
        " 包 共 " +
        this.header.prescriptionQuantity +
        " 包";
  }

  setTotalMediQty() {
    this.mediQtyTotal = this.line
      .map((el) => el.prescriptionTotalQty)
      .reduce((a, b) => a + b, 0);
  }

  getOnConsultInfo() {
    this.tOnConsultService
      .getOnConsultInfo(
        this.onConsultDataList.shopID,
        this.onConsultDataList.clthConsultNumber
      )
      .subscribe((data) => {
        this.onConsultDataList = data[0];

        var pGender = this.genderList.find(
          (gender) => gender.id == this.onConsultDataList.patientGender
        );

        this.patientGender_selection_Display =
          pGender != null
            ? pGender.chineseName + "/" + pGender.engName.toUpperCase()
            : "";
      });
  }

  formatDate(date: Date) {
    const newDate = new Date(date);
    return this.datepipe.transform(date, "yyyy/MM/dd");
    // return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }

  getPrintLine(presNum: string) {
    //this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.onConsultDataList = JSON.parse(localStorage.getItem("onConsultModel"));
    this.getOnConsultInfo();

    this.tPrescriptionService
      .getPrintLine2(NavigationComponent.selectedShopID.toString(), presNum)
      .subscribe((data) => {
        this.line = data;

        if (
          this.header.prescriptionCateID === "b01" ||
          this.header.prescriptionCateID === "b03"
        ) {
          //中草藥
          if (this.line.length != 0) {
            if (this.line.length <= 20) {
              const ll = this.line.slice(0, this.line.length);
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(ll);
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(ll);
              this.totalPrintWithCustomer = 1;
            } else if (this.line.length <= 40) {
              const ll = this.line.slice(0, 20);
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(ll);
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(ll);
              const aa = this.line.slice(20, this.line.length);
              this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(aa);
              this.presPartA.medi_lines.l22 = this.getOddMedi_lines(aa);
              this.totalPrintWithCustomer = 2;
            } else if (this.line.length <= 60) {
              const aa = this.line.slice(0, 20);
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(aa);
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(aa);
              const bb = this.line.slice(20, 40);
              this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(bb);
              this.presPartA.medi_lines.l22 = this.getOddMedi_lines(bb);
              const cc = this.line.slice(40, this.line.length);
              this.presPartA.medi_lines.l31 = this.getEvenMedi_lines(cc);
              this.presPartA.medi_lines.l32 = this.getOddMedi_lines(cc);
              this.totalPrintWithCustomer = 3;
            }
          }
        } else if (this.header.prescriptionCateID === "b02") {
          //濃縮中藥

          //20/30 medi cases

          //this.line1 = this.line;
          this.totalPrintWithCustomer = 1;
          var total_medi_have_detail = this.line.filter(
            (x) => x.mediDetail
          ).length;

          //console.warn("total_medi_have_detail = ", total_medi_have_detail);
          if (total_medi_have_detail == 0) {
            this.line1_detail = [];
            this.presPartA.medi_specialLines.l1 = [];

            if (this.line.length <= 20) {
              // max. n items =  20
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(this.line);
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(this.line);
              this.totalPrintWithCustomer = 1;
            } else if (this.line.length <= 40) {
              // 21 = n <= 40
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(
                this.line,
                0,
                20
              );
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(
                this.line,
                0,
                20
              );
              this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(
                this.line,
                20,
                this.line.length
              );
              this.presPartA.medi_lines.l22 = this.getOddMedi_lines(
                this.line,
                20,
                this.line.length
              );
              this.totalPrintWithCustomer = 2;
            } else if (this.line.length <= 60) {
              // max. n items = >20 && 40
              this.presPartA.medi_lines.l11 = this.getEvenMedi_lines(
                this.line,
                0,
                20
              );
              this.presPartA.medi_lines.l12 = this.getOddMedi_lines(
                this.line,
                0,
                20
              );

              this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(
                this.line,
                20,
                40
              );
              this.presPartA.medi_lines.l22 = this.getOddMedi_lines(
                this.line,
                20,
                40
              );

              this.presPartA.medi_lines.l31 = this.getEvenMedi_lines(
                this.line,
                40,
                this.line.length
              );
              this.presPartA.medi_lines.l32 = this.getOddMedi_lines(
                this.line,
                40,
                this.line.length
              );

              this.totalPrintWithCustomer = 3;
            }
          } else {
            //console.log("複方 total = " + total_medi_have_detail);
            this.presPartA.medi_specialLines.l1 = this.line.filter(
              (x) => x.mediDetail
            ); //add medi have detail 1 item
            const line_filtered = this.line.filter((x) => !x.mediDetail);
            if (total_medi_have_detail == 1) {
              if (line_filtered.length <= 14) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 1;
              } else if (line_filtered.length <= 34) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 14)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 14)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(14, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(14, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 2;
              } else if (line_filtered.length <= 54) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 14)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 14)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(14, 24)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(14, 24)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l31 = line_filtered
                  .slice(24, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l32 = line_filtered
                  .slice(24, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 3;
              } else {
                this.presPartA.medi_lines.l11 = this.line.filter(
                  (x, i) => !x.mediDetail && this.isEven(i)
                );
                this.presPartA.medi_lines.l12 = this.line.filter(
                  (x, i) => !x.mediDetail && this.isOdd(i)
                );
                this.totalPrintWithCustomer = 1;
              }
            } else if (total_medi_have_detail == 2) {
              if (line_filtered.length <= 10) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 1;
              } else if (line_filtered.length <= 30) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 10)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 10)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(10, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(10, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 2;
              } else if (line_filtered.length <= 50) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 10)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 10)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(10, 30)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(10, 30)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l31 = line_filtered
                  .slice(30, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l32 = line_filtered
                  .slice(30, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 3;
              }
            } else if (total_medi_have_detail == 3) {
              if (line_filtered.length <= 6) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 1;
              } else if (line_filtered.length <= 26) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 6)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 6)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(6, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(6, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 2;
              } else if (line_filtered.length <= 46) {
                this.presPartA.medi_lines.l11 = line_filtered
                  .slice(0, 6)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l12 = line_filtered
                  .slice(0, 6)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l21 = line_filtered
                  .slice(6, 26)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l22 = line_filtered
                  .slice(6, 26)
                  .filter((num, i) => this.isOdd(i));
                this.presPartA.medi_lines.l31 = line_filtered
                  .slice(26, line_filtered.length)
                  .filter((num, i) => this.isEven(i));
                this.presPartA.medi_lines.l32 = line_filtered
                  .slice(26, line_filtered.length)
                  .filter((num, i) => this.isOdd(i));
                this.totalPrintWithCustomer = 3;
              }
            } else {
              //分配複方
              var medi_details2 = this.line.filter((x) => x.mediDetail);
              let size = 0;
              this.presPartA.medi_specialLines.l1 = [];

              for (var x = 0; x < medi_details2.length; x++) {
                size += this.getMediDetailLength(medi_details2[x].mediDetail);
                if (size < this.SIZE_MEDI_DETAIL[1050]) {
                  this.presPartA.medi_specialLines.l1.push(medi_details2[x]);
                } else if (size < this.SIZE_MEDI_DETAIL[2100]) {
                  this.presPartA.medi_specialLines.l2.push(medi_details2[x]);
                } else if (size < this.SIZE_MEDI_DETAIL[3150]) {
                  this.presPartA.medi_specialLines.l3.push(medi_details2[x]);
                } else {
                  this.presPartA.medi_specialLines.l4.push(medi_details2[x]);
                }
              }

              console.log("details size = " + size);

              if (size < this.SIZE_MEDI_DETAIL[1050]) {
                this.totalPrintWithCustomer = 1;
              } else if (size < this.SIZE_MEDI_DETAIL[2100]) {
                this.totalPrintWithCustomer = 2;
              } else if (size < this.SIZE_MEDI_DETAIL[3150]) {
                this.totalPrintWithCustomer = 3;
              } else {
                this.totalPrintWithCustomer = 4;
              }

              if(line_filtered.length > 0){
                if (this.totalPrintWithCustomer == 1) {
                  if (line_filtered.length <= 20) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l21 =
                      this.getEvenMedi_lines(line_filtered);
                    this.presPartA.medi_lines.l22 =
                      this.getOddMedi_lines(line_filtered);
                    this.totalPrintWithCustomer += 1;
                  } else if (line_filtered.length <= 40) {
                    // 21 = n <= 40
                    this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l22 = this.getOddMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l31 = this.getEvenMedi_lines(
                      line_filtered,
                      20,
                      line_filtered.length
                    );
                    this.presPartA.medi_lines.l32 = this.getOddMedi_lines(
                      line_filtered,
                      20,
                      line_filtered.length
                    );
                    this.totalPrintWithCustomer += 2;
                  } else if (line_filtered.length <= 60) {
                    // max. n items = >20 && 40

                    this.presPartA.medi_lines.l21 = this.getEvenMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l22 = this.getOddMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l31 = this.getEvenMedi_lines(
                      line_filtered,
                      20,
                      line_filtered.length
                    );
                    this.presPartA.medi_lines.l32 = this.getOddMedi_lines(
                      line_filtered,
                      20,
                      line_filtered.length
                    );

                    this.totalPrintWithCustomer += 3;
                  }
                } else if (this.totalPrintWithCustomer == 2) {
                  let len = line_filtered.length;
                  if (len <= 20) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l31 =
                      this.getEvenMedi_lines(line_filtered);
                    this.presPartA.medi_lines.l32 =
                      this.getOddMedi_lines(line_filtered);

                    this.totalPrintWithCustomer += 1;
                  } else if (len <= 40) {
                    this.presPartA.medi_lines.l31 = this.getEvenMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l32 = this.getOddMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l41 = this.getEvenMedi_lines(
                      line_filtered,
                      20,
                      len
                    );
                    this.presPartA.medi_lines.l42 = this.getOddMedi_lines(
                      line_filtered,
                      20,
                      len
                    );
                    this.totalPrintWithCustomer += 2;
                  }
                } else if (this.totalPrintWithCustomer == 3) {
                  let len = line_filtered.length;
                  if (len <= 20) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l41 =
                      this.getEvenMedi_lines(line_filtered);
                    this.presPartA.medi_lines.l42 =
                      this.getOddMedi_lines(line_filtered);

                    this.totalPrintWithCustomer += 1;
                  } else if (len <= 40) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l41 = this.getEvenMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l42 = this.getOddMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l51 = this.getEvenMedi_lines(
                      line_filtered,
                      20,
                      len
                    );
                    this.presPartA.medi_lines.l52 = this.getOddMedi_lines(
                      line_filtered,
                      20,
                      len
                    );

                    this.totalPrintWithCustomer += 1;
                  }
                } else if (this.totalPrintWithCustomer == 4) {
                  let len = line_filtered.length;
                  if (len <= 20) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l51 =
                      this.getEvenMedi_lines(line_filtered);
                    this.presPartA.medi_lines.l52 =
                      this.getOddMedi_lines(line_filtered);

                    this.totalPrintWithCustomer += 1;
                  } else if (len <= 40) {
                    // max. n items =  20
                    this.presPartA.medi_lines.l51 = this.getEvenMedi_lines(
                      line_filtered,
                      0,
                      20
                    );
                    this.presPartA.medi_lines.l52 = this.getOddMedi_lines(
                      line_filtered,
                      0,
                      20
                    );

                    this.presPartA.medi_lines.l61 = this.getEvenMedi_lines(
                      line_filtered,
                      20,
                      len
                    );
                    this.presPartA.medi_lines.l62 = this.getOddMedi_lines(
                      line_filtered,
                      20,
                      len
                    );

                    this.totalPrintWithCustomer += 1;
                  }
                }
              }

            }
          }
        } else {
          this.line1 = this.line;
          this.totalPrintWithCustomer = 1;
        }
        this.setPharmacyPrintLines(data);
      });
  }

  isEven(i: number) {
    return i % 2 === 0;
  }
  isOdd(i: number) {
    return i % 2 !== 0;
  }

  getEvenMedi_lines(
    data: tPrescriptionLineModel_PrintPrescription[],
    start?: number,
    end?: number
  ) {
    //console.log("start:", start);
    //console.log("end:", end);
    if (start === undefined && end === undefined)
      return data.filter((num, i) => this.isEven(i));

    if (start !== undefined && end !== undefined)
      return data.slice(start, end).filter((num, i) => this.isEven(i));

    return [];
  }

  getOddMedi_lines(
    data: tPrescriptionLineModel_PrintPrescription[],
    start?: number,
    end?: number
  ) {
    //console.log("start:", start);
    //console.log("end:", end);
    if (start === undefined && end === undefined)
      return data.filter((num, i) => this.isOdd(i));

    if (start !== undefined && end !== undefined)
      return data.slice(start, end).filter((num, i) => this.isOdd(i));

    return [];
  }

  //Prescription (藥房專用)
  setPharmacyPrintLines(data: tPrescriptionLineModel_PrintPrescription[]) {
    this.prescriptionDetail.medi_PharmacyLines.l1 = data;
    this.totalPrintWithStaff = 1;
    return;
    // b01/b03 中草藥/零售中草藥
    if (this.isB01() || this.isB03()) {


      let a = [0, 12, 24, 36];

      if (data.length <= a[1]) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(
          a[0],
          data.length
        );
        this.totalPrintWithStaff = 1;
      } else if (data.length <= a[2]) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(a[0], a[1]);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(
          a[1],
          data.length
        );
        this.totalPrintWithStaff = 1;
      } else if (data.length <= a[3]) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(a[0], a[1]);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(a[1], a[2]);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(
          a[2],
          data.length
        );
        this.totalPrintWithStaff = 2;
      } else {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(a[0], a[1]);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(a[1], a[2]);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(a[2], a[3]);
        this.prescriptionDetail.medi_PharmacyLines.l4 = data.slice(
          a[3],
          data.length
        );
        this.totalPrintWithStaff = 2;
      }
    }
    //b02 顆粒(濃縮中藥)
    if (this.isB02()) {
      const len = data.length;
      //console.log("b02 size = " + len);
      if (data.length <= 8) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, len);
        this.totalPrintWithStaff = 1;
      } else if (data.length <= 16) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, 8);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(8, len);
        this.totalPrintWithStaff = 1;
      } else if (data.length <= 24) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, 8);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(8, 16);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(16, len);
        this.totalPrintWithStaff = 2;
      } else if (data.length <= 32) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, 8);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(8, 16);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(16, 24);
        this.prescriptionDetail.medi_PharmacyLines.l4 = data.slice(24, len);
        this.totalPrintWithStaff = 2;
      } else if (data.length <= 40) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, 8);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(8, 16);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(16, 24);
        this.prescriptionDetail.medi_PharmacyLines.l4 = data.slice(24, 32);
        this.prescriptionDetail.medi_PharmacyLines.l5 = data.slice(32, len);
        this.totalPrintWithStaff = 3;
      } else if (data.length <= 48) {
        this.prescriptionDetail.medi_PharmacyLines.l1 = data.slice(0, 8);
        this.prescriptionDetail.medi_PharmacyLines.l2 = data.slice(8, 16);
        this.prescriptionDetail.medi_PharmacyLines.l3 = data.slice(16, 24);
        this.prescriptionDetail.medi_PharmacyLines.l4 = data.slice(24, 32);
        this.prescriptionDetail.medi_PharmacyLines.l5 = data.slice(32, 40);
        this.prescriptionDetail.medi_PharmacyLines.l6 = data.slice(40, len);
        this.totalPrintWithStaff = 3;
      }
    }
  }

  isB01() {
    return this.header.prescriptionCateID == "b01" ? true : false;
  }

  isB02() {
    return this.header.prescriptionCateID == "b02" ? true : false;
  }

  isB03() {
    return this.header.prescriptionCateID == "b03" ? true : false;
  }

  displayCook(methodID: any) {
    return this.cookingMethod_selection.find((p) => p.methodID == methodID)
      .methodDesc;
  }

  GettCookingMethod() {
    this.tPrescriptionService
      .GettCookingMethod()
      .subscribe((data) => (this.cookingMethod_selection = data));
  }

  getPresPartA_MediLines_Odd(index: number) {
    const line = this.presPartA.medi_lines;
    switch (index) {
      case 0:
        return line.l11;
      case 1:
        return line.l21;
      case 2:
        return line.l31;
      case 3:
        return line.l41;
      default:
        return [];
    }
  }

  getPresPartA_MediLines_Even(index: number) {
    const line = this.presPartA.medi_lines;
    switch (index) {
      case 0:
        return line.l12;
      case 1:
        return line.l22;
      case 2:
        return line.l32;
      case 3:
        return line.l42;
      default:
        return [];
    }
  }

  getMedi_PharmacyLines_odd(index: number) {
    const line = this.prescriptionDetail.medi_PharmacyLines;
    switch (index) {
      case 0:
        return line.l1;
      case 1:
        return line.l3;
      case 2:
        return line.l5;
      default:
        return [];
    }
  }

  getMedi_PharmacyLines_even(index: number) {
    const line = this.prescriptionDetail.medi_PharmacyLines;
    switch (index) {
      case 0:
        return line.l2;
      case 1:
        return line.l4;
      case 2:
        return line.l6;
      default:
        return [];
    }
  }

  getPharmacyEmptyLines_b01(index: number) {
    const line = this.prescriptionDetail.medi_PharmacyLines;
    const maxMediLines = 12;
    switch (index) {
      case 0:
        return maxMediLines - line.l1.length;
      case 1:
        return maxMediLines - line.l3.length;
      case 2:
        return maxMediLines - line.l5.length;
      default:
        return 0;
    }
  }

  getPharmacyEmptyLines_b02(index: number) {
    const line = this.prescriptionDetail.medi_PharmacyLines;
    const maxMediLines = 8;
    switch (index) {
      case 0:
        return maxMediLines - line.l1.length;
      case 1:
        return maxMediLines - line.l3.length;
      case 2:
        return maxMediLines - line.l5.length;
      default:
        return 0;
    }
  }

  getMediDetailLength(text: string) {
    let len = 0;
    for (var i = 0; i < text.length; i++) {
      if (text.charCodeAt(i) > 256) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  }

  getMediSpecialLines(index: number) {
    const line = this.presPartA.medi_specialLines;
    switch (index) {
      case 0:
        return line.l1;
      case 1:
        return line.l2;
      case 2:
        return line.l3;
      case 3:
        return line.l4;
      default:
        return [];
    }
  }

  //new
  getB02_blanklines(index: number) {
    const maxRow = 10;
    const maxRowOfDetail = 14;
    let result = 0;
    let line = this.presPartA.medi_lines;
    let spline = this.presPartA.medi_specialLines;

    let lt = [];
    let splt;

    switch (index) {
      case 0:
        lt = line.l11;
        splt = spline.l1;
        break;
      case 1:
        lt = line.l21;
        splt = spline.l2;
        break;
      case 2:
        lt = line.l31;
        splt = spline.l3;
        break;
      case 3:
        lt = line.l41;
        splt = spline.l4;
        break;
    }

    if (splt.length > 0) {
      result = this.getCount_B02_detail_blankLines(
        lt,
        splt,
        maxRowOfDetail,
        maxRow
      );
    } else {
      result = maxRow - lt.length;
    }

    return result;
  }

  getCount_B02_detail_blankLines(
    line,
    spline,
    maxRowOfDetail: number,
    maxRowOfNormal: number
  ) {
    let result = 0;


    if (this.presPartA.medi_specialLines.l1.length > 3) {
      //let detailRow = Math.round(this.getB02_detailSize(spline) / 75);
      let detailRow = this.getB02_detailRow2(spline);
      result = detailRow > 13 ? 0 : maxRowOfDetail - detailRow;
      if(detailRow == 5) result = 7;
      // console.log(
      //   "#size: detailRow=" +
      //     detailRow +
      //     ", maxRowOfDetail=" +
      //     maxRowOfDetail +
      //     ", Add Blank=" +
      //     result
      // );
    } else if (spline.length > 0) {
      result = maxRowOfNormal - spline.length - line.length;
    }
    // console.log("@maxSize = " + result);
    return result;
  }

  getB02_detailRow2(list: tPrescriptionLineModel_PrintPrescription[]) {
    let row = 0;
    for (var x = 0; x < list.length; x++) {
      let detailSize = this.getMediDetailLength(list[x].mediDetail);
      if (detailSize == 0) continue;

      if (detailSize <= 75) row += 1;
      else if (detailSize <= 150) row += 2;
      else if (detailSize <= 225) row += 3;
      else if (detailSize <= 300) row += 4;
      else if (detailSize <= 375) row += 5;
    }
    return row;
  }

  getB02_detailSize(list: tPrescriptionLineModel_PrintPrescription[]) {
    let size = 0;
    for (var x = 0; x < list.length; x++) {
      size += this.getMediDetailLength(list[x].mediDetail);
    }
    return size;
  }
} //875
